import React, { ReactNode } from 'react';
import Multiselect, { MultiselectOption } from '@rio-cloud/rio-uikit/Multiselect';

interface FilterMultiselectProps {
    title: ReactNode;
    placeholder: string;
    options: MultiselectOption[];
    /** Currently selected option ids. */
    value: string[];
    /** Emits the raw selected ids; empty array means "no filter". */
    onChange: (selectedIds: string[]) => void;
    disabled?: boolean;
    /** Show the icon of selected items in the trigger. Useful when options carry icons. */
    showSelectedItemIcon?: boolean;
    /** Show all item icons in the trigger (selected highlighted, unselected grayed). */
    showUnselectedItemIcons?: boolean;
}

/**
 * Plain labelled multiselect used by the maintenance-data filters. Unlike CriticalityFilter it
 * applies no "all-selected == none" coercion: an empty selection stays empty (placeholder shown)
 * and is treated downstream as "no filter", matching the WFE filter UX.
 */
const FilterMultiselect: React.FC<FilterMultiselectProps> = ({
    title,
    placeholder,
    options,
    value,
    onChange,
    disabled = false,
    showSelectedItemIcon = false,
    showUnselectedItemIcons = false,
}) => (
    <div className="display-flex flex-column min-width-200">
        <span className="text-color-highlight-light margin-bottom-5">{title}</span>
        <Multiselect
            placeholder={placeholder}
            options={options}
            value={value}
            onChange={onChange}
            disabled={disabled}
            showSelectedItemIcon={showSelectedItemIcon}
            showUnselectedItemIcons={showUnselectedItemIcons}
        />
    </div>
);

export default FilterMultiselect;
